import React, { useCallback, useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import { MdTimer, MdTimerOff } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import ButtonImagePermission from "../../../../components/UI/Button/ButtonImagePermission";
import { AuthContext, funcionalidades } from "../../../../context/AuthContext";
import { paginatedViewActions } from "../../../../redux/paginatedView";
import useResponsabilidadeOrgao from "./useResponsabilidadeOrgao";

const iconsStyle = { marginTop: "6px", marginRight: "10px", color: "#000" };

const useTitleBar = ({ reduxKey }) => {
  const titleBarParams = useSelector((state) => state.paginatedView[reduxKey].titleBarParams);
  const dispatch = useDispatch();
  const { isAllowed, user } = useContext(AuthContext);
  const [isAllowedExecutarOs] = useState(isAllowed(funcionalidades.os.executarDiretor));
  const { responsabilidadeOrgao } = useResponsabilidadeOrgao(user.codigo);
  const [selectValue, setSelectValue] = useState(titleBarParams.selectValue !== null ? titleBarParams.selectValue : "");

  const setTitleBarParamsHandler = useCallback(
    (params) => {
      dispatch(
        paginatedViewActions.setTitleBarParams({
          reduxKey,
          titleBarParams: {
            ...titleBarParams,
            ...params,
          },
        }),
      );
    },
    [dispatch, reduxKey, titleBarParams],
  );

  const validationSchema = Yup.object().shape({ atividades: Yup.string().default("") });

  const initialValues = {};
  validationSchema._nodes.forEach((key) => {
    initialValues[key] = "";
  });

  useEffect(() => {
    // Define responsabilidade Diretor ou Executor
    if (selectValue === "" && responsabilidadeOrgao) {
      setSelectValue(responsabilidadeOrgao === "F" ? "E" : "D");
    }
  }, [responsabilidadeOrgao, selectValue, titleBarParams.selectValue]);

  useEffect(() => {
    if (titleBarParams.codAcao !== 3 && selectValue !== "") {
      setTitleBarParamsHandler({
        codAcao: selectValue === "D" ? 1 : 2,
        codUsuario: user.codigo,
      });
    } else {
      setTitleBarParamsHandler({ codUsuario: user.codigo });
    }
  }, [setTitleBarParamsHandler, selectValue, user.codigo, titleBarParams.codAcao]);

  // Selecionando a Diretor / Executor
  function SelecionarValor(e) {
    if (e.target.value === "D") {
      setTitleBarParamsHandler({ codAcao: 1, pageNumber: 1, selectValue: "D" });
    } else if (e.target.value === "E") {
      setTitleBarParamsHandler({ codAcao: 2, pageNumber: null, selectValue: "E" });
    } else {
      setTitleBarParamsHandler({ codAcao: 3, isTimer: 0, pageNumber: null, selectValue: "T" });
    }
    setSelectValue(e.target.value);
  }

  const titleBar = (
    <>
      <select
        value={selectValue}
        className="form-control w-auto"
        style={{ marginRight: 10 }}
        // disabled={!isAllowedExecutarOs || responsabilidadeOrgao === null}
        disabled={responsabilidadeOrgao === null}
        onChange={SelecionarValor}
      >
        <option value="T">Todas</option>
        <option value="D">Atividades para Diretor</option>
        <option value="E">Atividades para Executor</option>
      </select>

      {isAllowedExecutarOs && (responsabilidadeOrgao === "C" || responsabilidadeOrgao === "S") && (
        <ButtonImagePermission
          permission={funcionalidades.os.executarDiretor}
          variant="bg-transparent"
          className="btn-lg text-success pa-0 p-0"
          buttonImage={
            titleBarParams.isTimer ? (
              <MdTimerOff size="25" style={iconsStyle} />
            ) : (
              <MdTimer size="25" style={iconsStyle} />
            )
          }
          tooltipImage={`${titleBarParams.isTimer ? "Desativar" : "Ativar"} filtro OS Com Pedidos de Prorrogação`}
          onClick={() => {
            setTitleBarParamsHandler({ isTimer: titleBarParams.isTimer === 1 ? 0 : 1 });
          }}
        />
      )}
      <div className="card-divider d-none d-sm-block" />
    </>
  );

  return {
    titleBar,
    titleBarParams,
  };
};

export default useTitleBar;
